import type { NextRequest } from "@/modules/fetch/types"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

type postJobAdSeenStateParams = {
  jobAdId: string
  lastSeenTime?: string
  nextRequest?: NextRequest
}

const API_ENDPOINT_PATH = `/v2alpha2/jobads/seen`

export const postJobAdSeenState = async (params: postJobAdSeenStateParams): Promise<void> => {
  const { jobAdId, nextRequest } = params

  return fetcher(API_ENDPOINT_PATH, {
    nextRequest,
    requestInit: {
      body: JSON.stringify({ job_ad_id: jobAdId }),
      method: "POST",
    },
    serviceDomain: "KRAKEND_API",
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(API_ENDPOINT_PATH, { jobAdId }))
}
